import { assetUrl } from './url';

/**
 * Get the full URL for an image, handling both absolute and relative URLs
 */
export const getImageUrl = (imageUrl: string | undefined | null): string | undefined => {
  if (!imageUrl) return undefined;
  const url = assetUrl(imageUrl);
  return url || imageUrl || undefined;
};
